module.exports = __webpack_public_path__ + "img/about-ch4-sectors-energy.9069ba1e.png";